import pluralize from 'pluralize';

export function plural(value, number) {
  return pluralize(value, number);
}
